import { handleRequest } from "../utilities/requestHandler";

export const updateCustomerSites = (req_body) =>
    handleRequest("post","/cus_sites/updatesites",req_body);

export const getCustomSitesData = (query) =>
    handleRequest("post", "/cus_sites/getcustom", { query });

export const getSiteAddresses = (siteId) =>
    handleRequest("get", `/site_addresses?site_id=${siteId}`);

export const createSiteAddress = (payload) =>
    handleRequest("post", "/site_addresses", payload);

export const updateSiteAddress = (id, payload) =>
    handleRequest("put", `/site_addresses/${id}`, payload);

export const deleteSiteAddress = (id) =>
    handleRequest("delete", `/site_addresses/${id}`);

export const getUserAllocations = (userId) =>
    handleRequest("get", `/users/allocations/${userId}`);

export const getSiteAddressesNew = (siteId,addressType)=>
    handleRequest("get", `/site_addresses?site_id=${siteId}&address_type=${addressType}`);